import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=6b58d3fc&scoped=true&"
import script from "./ChartItem.vue?vue&type=script&lang=js&"
export * from "./ChartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58d3fc",
  null
  
)

export default component.exports